var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition-fade',[(_vm.show)?_c('div',{staticClass:"footer-submit",on:{"click":_vm.click}},[_vm._v("\n\t\t立即预约咨询\n\t\t"),_c('i'),_vm._v(" "),_c('i'),_vm._v(" "),_c('i')]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }